import { render } from "./ColumnList.vue?vue&type=template&id=66d69dc2&lang=pug"
import script from "./ColumnList.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__